<aside class="aside-menu">

</aside>


// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/components/app-aside/app-aside.component.html